<div class="grid-container">
  <ch-facility-banner [facility]="facility$ | async"> </ch-facility-banner>
  <div class="facility-nav">
    <ch-side-nav [menuItems]="menuItems"></ch-side-nav>
  </div>
  <div class="facility-body">
    <router-outlet></router-outlet>
  </div>
</div>
